import { Check, XCircle } from 'lucide-react'
import { cn } from '@/lib/utils/helpers'
import {
  getReimbursementDocumentUploadStatusBadgeClasses,
  normalizeReimbursementUploadStatusLabel,
  reimbursementDocumentUploadStatusShowsCheckIcon,
  reimbursementDocumentUploadStatusShowsXCircleIcon,
} from '../../utils/reimbursementDocumentUploadStatus'

export interface ReimbursementDocumentUploadStatusBadgeProps {
  status: string
  className?: string
}

export function ReimbursementDocumentUploadStatusBadge({
  status,
  className,
}: ReimbursementDocumentUploadStatusBadgeProps) {
  const label = normalizeReimbursementUploadStatusLabel(status)
  const showCheck = reimbursementDocumentUploadStatusShowsCheckIcon(status)
  const showXCircle = reimbursementDocumentUploadStatusShowsXCircleIcon(status)

  return (
    <span className={cn(getReimbursementDocumentUploadStatusBadgeClasses(status), className)}>
      {showCheck ? <Check className="h-3 w-3 shrink-0" aria-hidden /> : null}
      {showXCircle ? <XCircle className="h-3 w-3 shrink-0" aria-hidden /> : null}
      {label}
    </span>
  )
}
